var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBots = function SvgBots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.931 11.532H2.316v4.841h1.615zM21.683 11.532h-1.615v4.841h1.615zM12.805 7.226v-1.52c.221-.198.371-.476.399-.79a1.23 1.23 0 0 0-1.211-1.323 1.209 1.209 0 0 0-.802 2.114v1.519H4.735v13.18h14.523V7.227h-6.455zm-2.896 6.81a1.658 1.658 0 0 1-2.343-2.343 1.658 1.658 0 0 1 2.343 2.343m6.524 0a1.657 1.657 0 0 1-2.343-2.343 1.657 1.657 0 0 1 2.343 2.343"
  })));
};
export default SvgBots;